exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{\n  width:100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/exposure/acc-exp-fund/acc-exp-fund.component.css
// module id = ../../../../../src/app/pages/exposure/acc-exp-fund/acc-exp-fund.component.css
// module chunks = main